import toFixedValue, { toFixedValueInt } from 'app/common/lib/toFixedValue'


export const apiLimitToString = (limit_: string | number | null | undefined) => {
  if (limit_ === null || limit_ === undefined) return null
  const limit = typeof limit_ === 'number' ? limit_ : parseFloat(limit_)
  return (
    limit % 1
      ? toFixedValue(limit)
      : toFixedValueInt(limit)
  )
}
